document.addEventListener('teeinblue-event-after-cart-added', function() {
  // 1. Cart Drawer (Quick Cart)
  window.Shopify.theme.sections.instances
    .filter(instance => instance.type === 'quick-cart')
    .forEach(instance => instance.refreshQuickCart());

  // 2. Icon Cart on Header (Desktop & Mobile)
  fetch('/?section_id=header')
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    
    const selectors = [
      '.header__content-desktop [data-header-cart]',
      '.header__content-mobile [data-header-cart]'
    ];
    selectors.forEach(selector => {
      const newEl = doc.querySelector(selector);
      const oldEl = document.querySelector(selector);
      if (newEl && oldEl) {
        oldEl.innerHTML = newEl.innerHTML;
      }
    });
  });
})